var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / UI"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8929 17.3614L5.18877 10.2302C4.86416 9.93001 4.86416 9.44503 5.18877 9.14407L12.8929 2.01286C13.3615 1.57856 14.124 1.57856 14.5934 2.01286C15.062 2.44715 15.062 3.15201 14.5934 3.58631L8.00292 9.68752L14.5934 15.7872C15.062 16.2223 15.062 16.9271 14.5934 17.3614C14.124 17.7957 13.3615 17.7957 12.8929 17.3614Z",
    fill: "#2D49FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.c0e2c5c5.svg";
export { ForwardRef as ReactComponent };